import { type PropsWithChildren, createContext, useContext, useEffect, useMemo } from 'react'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { ContactsAnalyticsPageStore } from 'pages/analytics/pages/contacts/store/contactsAnalyticsPageStore'

const ContactsAnalyticsPageContext = createContext<ContactsAnalyticsPageStore | null>(null)

export const useContactsAnalyticsPageContext = () => {
  const context = useContext(ContactsAnalyticsPageContext)

  if (context === null)
    throw new Error(
      'You have forgotten to wrap your root component with ContactsAnalyticsPageProvider'
    )

  return context
}

export const ContactsAnalyticsPageProvider = ({ children }: PropsWithChildren) => {
  const entities = useEntitiesContext()
  const store = useMemo(() => new ContactsAnalyticsPageStore(entities), [])

  useEffect(() => {
    void store.init()

    return () => {
      store.dispose()
    }
  }, [])

  return (
    <ContactsAnalyticsPageContext.Provider value={store}>
      {children}
    </ContactsAnalyticsPageContext.Provider>
  )
}
